import { createI18n } from 'vue-i18n';

// TODO: FIXME load dynamically
import formats from '../resources/i18n/en-us/formats.js';
import messages from '../resources/i18n/en-us/messages.js';

export default createI18n({
    locale: import.meta.env.VITE_APP_I18N_LOCALE || 'en',
    fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: messages,
    datetimeFormats: formats['date-format'],
    numberFormats: formats['number-format'],
});
